import { render } from "./CameraComponent.vue?vue&type=template&id=3174c018"
import script from "./CameraComponent.vue?vue&type=script&lang=js"
export * from "./CameraComponent.vue?vue&type=script&lang=js"

import "./CameraComponent.vue?vue&type=style&index=0&id=3174c018&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__